"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = useRowActions;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var permissions_1 = require("../../../../../hooks/permissions");
var IUser_1 = require("../../../../../interfaces/IUser");
var useDeleteItem_1 = require("./useDeleteItem");
function useRowActions() {
    var canDelete = (0, permissions_1.usePermission)(IUser_1.IPermissions.BADGES).canDelete;
    var confirmDelete = (0, useDeleteItem_1.useDeleteItem)().confirmDelete;
    var rowActions = (0, react_3.useCallback)(function (item) {
        return canDelete
            ? [
                {
                    key: "delete",
                    element: ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "danger-soft", "aria-label": "Delete ".concat(item.name), onPress: function () { return confirmDelete(item); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:delete", className: "text-danger", width: 18, height: 18 }) }, "delete")),
                },
            ]
            : [];
    }, [confirmDelete, canDelete]);
    return { rowActions: rowActions };
}
